let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iIXZI")).then(() => parcelRequire('emiD2'));